export default __webpack_public_path__ + "static/media/711.fbded8d3.png";